import _ from "lodash"
import defaultMessages from "../../i18n/default.messages"
import menuMessages from "../../i18n/default.messages"

let messages = {
    messages: {
        'es-MX': {
            moduleTitle: 'Bicicletas',
            tblTitle: 'Lista de bicis de {locationName}',
            tblbutton: 'Nueva bici',
            mdlSave: 'Guardar',
            mdlCancel: 'Cancelar',
            lblName: "Nombre",
            lblDescription: "Descripcion",
            dlgUploadTitle: "Editar bici",

            headerName: 'Nombre',
            headerLocation: 'Localidad',
            headerComments: 'Descripcion',
            headerEstado: 'Estado',
            headerAction: 'Acciones',

            lblSearch: 'Buscar',
            lblEdit: 'Editar',
            lblImage: 'Galería de imágenes',
            lblAttribe: 'Atributos',
            lblback: 'Atras',

        },
        en: {
            moduleTitle: 'Bikes',
            tblTitle: "{locationName}'s bike List",
            tblbutton: 'New Bike',
            mdlSave: 'Save',
            mdlCancel: 'Cancel',
            lblName: "Name",
            lblDescription: "Comments",
            dlgUploadTitle: "Edit bike",

            headerName: 'Name',
            headerLocation: 'Location',
            headerComments: 'Comments',
            headerEstado: 'Status',
            headerAction: 'Actions',

            lblSearch: 'Search',
            lblEdit: 'Edit',
            lblImage: 'Image gallery',
            lblAttribe: 'Attributes',
            lblback: 'Go back',

        }
    }
}

export default _.merge(messages, defaultMessages, menuMessages)